import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import LoadingCentered from "../../common/loaders/loadingcentered";
import { generatePdfReport } from "../../api";
import { authSelector } from "../../reducers";
import { logoFetch, logoUrl } from "../../common/utils";

export function PdfModal({ contract, setPdf }) {
  const { t, i18n } = useTranslation();
  const [objectURL, setObjectURL] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  const { companyLogoUrl, companyUrl, companyEmail, companyName, companyBusinessId, companyAddress1, companyAddress2, companyAddress3, company } = useSelector(authSelector);
  const organizationLogoUrl = company?.logoUrl;

  const hide = () => setPdf(null);

  useEffect(() => {
    async function fetchReport() {
      setObjectURL("");
      setShowLoading(true);
      if (contract !== null) {
        //const json = (await contractGet(contract.contractId)).data;
        const json = { ...contract, company: { ...contract.company }, details: { ...contract.details } };

        if (!json.person) json.person = {}; // ensure person object exists in json, otherwise pdf generation fails without person"

        // if contract is a model, use fresh company info from auth token
        if (json.identifier !== null && json.identifier.startsWith("M")) {
          json.company.email = companyEmail;
          json.company.url = companyUrl;
          json.company.logoUrl = organizationLogoUrl ? organizationLogoUrl : companyLogoUrl;
          json.company.name = companyName;
          json.company.businessId = companyBusinessId;
          json.company.address1 = companyAddress1;
          json.company.address2 = companyAddress2;
          json.company.address3 = companyAddress3;
        }

        let logo = "";
        if (json.company.logoUrl?.length) {
          if (json.company.logoUrl.startsWith("images/")) {
            logo = logoUrl(json.company.logoUrl); // orgization logo from eSalary
          } else {
            logo = logoUrl("", json.company.logoUrl); // organization logo from S3
          }
        } else {
          logo = logoUrl(companyLogoUrl, organizationLogoUrl); // company logo from organization / auth token if the corresponding fields in json.company are empty
        }

        json.company.logo = await logoFetch(logo);
        if (!json.company.url) json.company.url = companyUrl;

        const lang = json.details.language ?? "fi";
        await i18n.loadNamespaces(["cbacodes"]);
        await i18n.loadLanguages(lang);
        const cbaCodes = i18n.getResourceBundle(lang, "cbacodes") ?? {};
        if (json.details.cbaCode) json.details.cbaText = cbaCodes[json.details.cbaCode];
        const res = await generatePdfReport("tyosopimus3", json);
        setObjectURL(URL.createObjectURL(res.data));
        setShowLoading(false);
      //window.open(objectURL, "_blank");
      }
    }
    fetchReport();
  }, [contract]);

  return (
    <Modal show={contract !== null} onHide={hide} size="xl" fullscreen="lg-down">
      <Modal.Header closeButton>{t("PdfPreview", "Pdf-esikatselu")}</Modal.Header>
      <LoadingCentered show={showLoading} />
      <iframe style={{ height: "85vh" }} src={objectURL} />
    </Modal>
  );
}
